// extracted by mini-css-extract-plugin
module.exports = {"ControlPanelDeviceCard":"ControlPanelDeviceCard_ControlPanelDeviceCard__3IkQJ","ControlPanelDeviceCard__Header":"ControlPanelDeviceCard_ControlPanelDeviceCard__Header__1ZtL5"};